import React, { useState } from 'react';
import { hooks as commonHooks } from '@sitebuilder/common';
import { TextInput, IncDecNumberInput } from './index';

export const getNumberFromString = (str: string) => {
    const regex = /[+-]?\d+(\.\d+)?/g;
    return str?.match(regex)?.map((s) => parseFloat(s))[0];
};

export interface UnitSelectorProps {
    value: string;
    defaultValue?: string;
    sideLabel?: string;
    onChange: (value: string) => void;
}

interface Unit {
    label: string;
    value: string;
}

const units: Unit[] = [
    {
        label: 'select',
        value: '',
    },
    {
        label: 'px',
        value: 'px',
    },
    {
        label: 'pt',
        value: 'pt',
    },
    {
        label: '%',
        value: '%',
    },
    {
        label: 'em',
        value: 'em',
    },
    {
        label: 'rem',
        value: 'rem',
    },
    {
        label: 'other',
        value: 'other',
    },
];

const UnitSelector = (props: UnitSelectorProps) => {
    const { defaultValue, value, sideLabel, onChange } = props;

    const defaultNumber: number | string | undefined = value
        ? getNumberFromString(value)
        : defaultValue && getNumberFromString(defaultValue);

    const defaultUnit = value
        ? value.replace(/\d+/, '')
        : defaultValue && defaultValue.replace(/\d+/, '');

    const isDefaultUnitOther =
        defaultUnit && !units.map((unit) => unit.value)?.includes(defaultUnit);

    const [number, setNumber] = useState<number | string | undefined>(defaultNumber);
    const [unit, setUnit] = useState<string>(
        defaultUnit ? (isDefaultUnitOther ? 'other' : defaultUnit) : ''
    );
    const [otherUnit, setOtherUnit] = useState<string>(isDefaultUnitOther ? defaultUnit : '');

    commonHooks.useDidUpdateEffect(() => {
        if (number !== null && unit !== 'other') {
            onChange(`${number}${unit}`);
        } else {
            onChange(`${number}${otherUnit}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [number]);

    const handleOptionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        e.preventDefault();
        setUnit(e.target?.value);

        if (number !== null) {
            onChange(`${number}${e.target?.value}`);
        }
    };

    const handleChangeText = (e: React.ChangeEvent<HTMLInputElement>) => {
        setOtherUnit(e.target?.value);

        if (number !== null) {
            onChange(`${number}${e.target?.value}`);
        }
    };

    return (
        <div className="unit-selector">
            <IncDecNumberInput
                defaultValue={Number(defaultNumber)}
                onChange={(number) => setNumber(number)}
            />
            <div className="custom-select">
                <select
                    className="custom-select-input"
                    onChange={handleOptionChange}
                    defaultValue={unit}
                    data-testid="custom-select-input"
                >
                    {units.length > 0 &&
                        units.map((unit: Unit, i: number) => (
                            <option key={`${unit.label}-${i}`} id={unit.label} value={unit.value}>
                                {unit.label}
                            </option>
                        ))}
                </select>
            </div>
            {unit === 'other' && (
                <TextInput
                    label={''}
                    placeholder={'unit'}
                    value={otherUnit}
                    onChange={handleChangeText}
                    labelId={'custom-unit-label'}
                    inputId={'custom-text-unit'}
                />
            )}
            {sideLabel && <p className="side-label">{sideLabel}</p>}
        </div>
    );
};

export default UnitSelector;
